import { IXC_MUTUALFUNDS_V1_FUND_ORDER_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-mutualfunds-v1-fund-order-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcMutualfundsV1FundOrderStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface MutualFundsFundOrderStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcMutualfundsV1FundOrderStatus | undefined;
}

export function MutualFundsFundOrderStatusPill({ isPending, status, ...props }: MutualFundsFundOrderStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_MUTUALFUNDS_V1_FUND_ORDER_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcMutualfundsV1', enumName: 'IxcMutualfundsV1FundOrderStatus', value: status }} />
    </Pill>
  );
}
